import React, { FunctionComponent } from "react";
import styles from "./BarCard.module.scss";
import BarCardProps from "./BarCardProps.interface";

import { useInView } from "react-intersection-observer";
import combineClasses from "helpers/combine-classes";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getImageCrop from "app/media/helpers/getImageCrop";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Paragraph from "components/Paragraph/Paragraph";
import Button from "components/Button/Button";
import urlBuilder from "app/umbraco/helpers/urlBuilder";
import LazyLoad from "react-lazyload";

const BarCard: FunctionComponent<BarCardProps> = (props) => {
  const [wrapperElementRef, inView] = useInView({
    triggerOnce: false,
    threshold: 0.4,
    rootMargin: "50% -40px 50% 0px",
  });
  const isInViewClass = inView === true ? "in_view" : undefined;

  const image = props.content.media
    ? props.content.media
    : props.content.logo
    ? props.content.logo
    : undefined;
  const imageCrop = getImageCrop(
    image?.umbracoFile.crops,
    props.settings.imageCrop,
    "Fullscreen (4:3)"
  );
  const imageAspectRatio = getImageAspectRatio(
    imageCrop,
    image?.umbracoWidth,
    image?.umbracoHeight
  );

  const logoUrl = props?.content?.logo
    ? urlBuilder(props?.content?.logo?.umbracoFile.src).toString()
    : "";

  return (
    <div
      className={combineClasses(styles.wrapper, isInViewClass)}
      ref={wrapperElementRef}
    >
      <div className={styles.inner}>
        {/* Media */}
        {props.content.media ? (
          <div className={styles.image_wrapper}>
            <div className={styles.main_image}>
              {/* Image */}
              <ImageViewer
                className={styles.image}
                src={props.content?.media?.umbracoFile.src}
                focalPoint={props.content.media.umbracoFile.focalPoint}
                aspectRatioX={imageAspectRatio.aspectRatioX}
                aspectRatioY={imageAspectRatio.aspectRatioY}
              />
            </div>
            <div className={styles.secondary_image}>
              {/* Logo */}
              <LazyLoad>
                <img
                  src={logoUrl}
                  alt={`Logo: ${props.content.heading}}`}
                  className={styles.logo}
                />
              </LazyLoad>
            </div>
          </div>
        ) : null}

        {/* Content */}
        <div className={styles.content}>
          {/* Heading */}
          {props.content.heading ? (
            <h3 className={styles.heading}>{props.content.heading}</h3>
          ) : null}

          {props.content.tagline ? (
            <Paragraph
              className={styles.tagline}
              innerHTML={props.content.tagline}
            />
          ) : null}

          {/* Buttons */}
          {props.content.button && props.content.button.length > 0 ? (
            <div className={styles.buttons}>
              {props.content.button.map((button) => (
                <Button
                  key={button.contentUdi}
                  to={button.content.link}
                  variant={button.content.variant}
                  {...button.content}
                >
                  {button.content.label}
                </Button>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BarCard;
